var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"standalone xs-f-small max-at-tweak text-left",attrs:{"href":_vm.href,"role":"menuitem"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }